export enum MODALS {
  COMMON_MODAL = 'commonModal',
  LOGOUT_WARNING_MODAL = 'logoutWarningModal',
  SECURITY_KEY_MODAL = 'securityKeyModal',
  ASSET_VIEW_MODAL = 'assetViewModal',
  NOTIFICATION_PANEL = 'notificationPanel',
  PAYMENT_MODAL = 'paymentModal',
  PAYMENT_SUCCESSFUL = 'paymentSuccessful',
  PASSPHRASE = 'passphrase',
}
